import { sumBy } from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import Table from '../ReusableComponents/Table/Table';
import TablePaper from '../ReusableComponents/Table/TablePaper';
import TableHead from '../ReusableComponents/Table/TableHead';
import HeaderRow from '../ReusableComponents/Table/HeaderRow';
import HeaderCell from '../ReusableComponents/Table/HeaderCell';
import TableBody from '../ReusableComponents/Table/TableBody';
import historyProps from '../../Lib/Utils/PropTypes/history-props';
import matchProps from '../../Lib/Utils/PropTypes/match-props';
import styles from './BillPaymentDetail.module.css';
import paymentHeaders from '../../Lib/Utils/Table/Headers/bill-payment-detail-payment-headers';
import creditHeaders from '../../Lib/Utils/Table/Headers/bill-payment-detail-credit-headers';
import PaymentRow from './PaymentRow';
import CreditRow from './CreditRow';

/**
 * Creates the table headers from objects imported here.
 *
 * @param {arrayOf} headerArr array of header value objects
 *  @property {object} header individual objects with header values
 *    @property {string} label the label value
 *    @property {number} key unique key for react components
 *
 * @returns {object} header cell components to be used by the table.
 */
const createHeaders = (headerArr) =>
  headerArr.map(({ value, align, key }) => (
    <HeaderCell key={key} padding="normal" align={align}>
      {value}
    </HeaderCell>
  ));

class BillPaymentDetail extends Component {
  constructor(props) {
    super(props);

    const {
      getBillPayment,
      match: {
        params: { id, billPaymentId },
      },
    } = this.props;

    this.handleBackClick = this.handleBackClick.bind(this);
    getBillPayment(id, billPaymentId);
  }

  handleBackClick() {
    const { history, match } = this.props;
    const userId = match.params.id;
    if (history.length > 2) {
      history.goBack();
    } else {
      history.push(`/users/${userId}/bill-payments`);
    }
  }

  render() {
    const {
      billPayment: { bills, credits, document_number, payment_date },
    } = this.props;

    if (!document_number) {
      return null;
    }

    return (
      <div className={styles.root}>
        <div className={styles.rootChildContainer}>
          <div>
            <h2 className={styles.header} id="bcd-invoice-header">
              {`Document #${document_number}`}
            </h2>
            <p className={styles.subText}>
              Updates will not be reflected for up to 5 minutes
            </p>
            <div className={styles.row}>
              <div className={styles.halfRow}>
                <strong>Payment Date:</strong>
                <p className={styles.fieldStyling} id="bcd-due-date">
                  {moment(payment_date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                </p>
              </div>
              <div className={styles.halfRow}>
                <strong>Payment Total:</strong>
                <p className={styles.fieldStyling} id="bcd-due-date">
                  {numeral(
                    sumBy(bills, 'payment') - sumBy(credits, 'amount'),
                  ).format('$0,0.00')}
                </p>
              </div>
            </div>
          </div>
          <div className={styles.tableContainer}>
            <h5 className={styles.tableTitle}>Payments</h5>
            <TablePaper className={styles.tablePaper}>
              <Table>
                <TableHead>
                  <HeaderRow>{createHeaders(paymentHeaders)}</HeaderRow>
                </TableHead>
                <TableBody>
                  {bills.map((payment) => (
                    <PaymentRow
                      key={payment.payment_bill_line_id}
                      payment={payment}
                    />
                  ))}
                </TableBody>
              </Table>
              <div className={styles.totalContainer}>
                <div className={styles.totalCell}>Totals</div>
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.quantityTotal}>
                  {numeral(sumBy(bills, 'payment')).format('$0,0.00')}
                </div>
              </div>
            </TablePaper>
            <div className={styles.tableSpacer} />
          </div>
          <div className={styles.tableContainer}>
            <h5 className={styles.tableTitle}>Credits</h5>
            <TablePaper className={styles.tablePaper}>
              <Table>
                <TableHead>
                  <HeaderRow>{createHeaders(creditHeaders)}</HeaderRow>
                </TableHead>
                <TableBody>
                  {credits.map((credit) => (
                    <CreditRow
                      key={credit.payment_credit_line_id}
                      credit={credit}
                    />
                  ))}
                </TableBody>
              </Table>
              <div className={styles.totalContainer}>
                <div className={styles.totalCell}>Totals</div>
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.totalCell} />
                <div className={styles.quantityTotal}>
                  {numeral(sumBy(credits, 'amount')).format('$0,0.00')}
                </div>
              </div>
            </TablePaper>
            <div className={styles.tableSpacer} />
          </div>
          <div className={styles.buttonRow}>
            <Button
              id="bc-detail-back"
              fullWidth
              variant="contained"
              className={styles.button}
              onClick={this.handleBackClick}
            >
              Back
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

BillPaymentDetail.propTypes = {
  history: historyProps.isRequired,
  match: matchProps.isRequired,
  billPayment: PropTypes.shape({}).isRequired,
  getBillPayment: PropTypes.func.isRequired,
};

export default BillPaymentDetail;
